import React, { useEffect, useState } from "react";
import { Col, Form, FormCheck, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const PreSelectedFleets = (props) => {
  const [fleetNumberList, setFleetNumberList] = useState([]);
  const [groupByWashtypeList, setGroupByWashtypeList] = useState([]);
  const sortAlphaNum = (a, b) => a.localeCompare(b, "en", { numeric: true });
  const { t } = useTranslation();
  useEffect(() => {
    setFleetNumberList(props.preSelectedFleetNumberList);
  }, [props]);

  useEffect(() => {
    const sortedFleetNumberList = [...fleetNumberList].sort((a, b) => {
      if (a.washtypeId !== b.washtypeId) {
        return a.washtypeId - b.washtypeId;
      }
      return a.fleetNumber.localeCompare(b.fleetNumber, "en", {
        numeric: true,
      });
    });

    const output = [];
    const washTypeMap = {};
    let washTypeIds = [];

    sortedFleetNumberList.forEach((fleet) => {
      const washtypeId = fleet.washtypeId;
      if (!washTypeIds.includes(washtypeId)) {
        washTypeIds.push(washtypeId);
        washTypeMap[washtypeId] = output.length;
        output.push({
          washTypeName: fleet.name,
          instruction: fleet.instructions,
          fleetList: [fleet],
        });
      } else {
        output[washTypeMap[washtypeId]].fleetList.push(fleet);
      }
    });
    setGroupByWashtypeList(output);
  }, [fleetNumberList]);

  const handleCheckboxChange = (index, itemIndex, isChecked) => {
    setGroupByWashtypeList((prevGroupByWashtypeList) => {
      const updatedGroupByWashtypeList = [...prevGroupByWashtypeList];
      updatedGroupByWashtypeList[index].fleetList[itemIndex].isSelected =
        isChecked ? 1 : 0;
      return updatedGroupByWashtypeList;
    });
  };

  return (
    <div>
      <Col sm="12">
        {groupByWashtypeList?.map(
          ({ washTypeName, instruction, fleetList }, index) => (
            <Row
              className="form-align-center"
              key={washTypeName}
              style={{
                border: "1px solid #adadadff",
                borderRadius: "6px",
                padding: "16px 18px",
                margin: "12px 0 18px 0",
                background: "#f4f8fb",
              }}
            >
              <Form.Group as={Col} className="mb-3">
                <Row>
                  <Form.Label
                    column
                    style={{ fontSize: "15px", paddingBottom: "0px" }}
                  >
                    <b>
                      {t("washtype.label")}
                      {": "}
                    </b>{" "}
                    {washTypeName}
                  </Form.Label>
                </Row>
                {instruction?.length > 3 && (
                  <Row>
                    <Col sm="12">
                      <div
                        style={{
                          border: "1px solid #b3d0f7",
                          borderRadius: "6px",
                          padding: "16px 18px",
                          margin: "12px 0 18px 0",
                          background: "#e9f3fb",
                        }}
                      >
                        <div
                          style={{
                            fontWeight: 600,
                            fontSize: "16px",
                            color: "#495057",
                            marginBottom: 6,
                          }}
                        >
                          {t("instructions.label")}
                        </div>
                        <div
                          style={{
                            fontSize: "15px",
                            color: "#333",
                            marginBottom: 10,
                          }}
                        >
                          {instruction}
                        </div>
                      </div>
                    </Col>
                  </Row>
                )}
                <Row>
                  <Row>
                    <Form.Label
                      column
                      sm="3"
                      style={{ fontSize: "15px", paddingTop: "0px" }}
                    >
                      <b>{t("vehicleNumbers.label")}</b>
                    </Form.Label>
                  </Row>
                  <Row>
                    {fleetList?.map((item, itemIndex) => (
                      <Col key={item.fleetNumber} sm="3">
                        <FormCheck
                          name={item.fleetNumber + item.washtypeId}
                          checked={item.isSelected === 1}
                          onChange={(e) =>
                            handleCheckboxChange(
                              index,
                              itemIndex,
                              e.target.checked,
                            )
                          }
                          label={item.fleetNumber}
                        />
                      </Col>
                    ))}
                  </Row>
                </Row>
              </Form.Group>
            </Row>
          ),
        )}
      </Col>
    </div>
  );
};

export default PreSelectedFleets;
